'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = injectPreparedData;

var _fromGraphQL = require('react-relay/lib/fromGraphQL');

var _fromGraphQL2 = _interopRequireDefault(_fromGraphQL);

var _reactRelay = require('react-relay');

var _reactRelay2 = _interopRequireDefault(_reactRelay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function injectPreparedData(data) {
    var storeData = _reactRelay2.default.Store.getStoreData();

    data.forEach(function (_ref) {
        var concreteQuery = _ref.query;
        var result = _ref.result;

        var query = _fromGraphQL2.default.Query(concreteQuery);

        storeData.handleQueryPayload(query, result);
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-relay/lib/injectPreparedData.js
// module id = 1489
// module chunks = 0